import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import React, { useState } from 'react'
import RoznicaCITRZiSHeader from './RoznicaCITRZiSHeader'
import RoznicaCITRZiSList from './RoznicaCITRZiSList'

function InformacjaDodatkowaPodatekDochodowyOpcjonalna(props) {
  const [isExpanded, setIsExpanded] = useState(
    initExpanded(props) || initDetailsVisible(props),
  )
  const [isDetailsVisible, setIsDetailsVisible] = useState(
    initDetailsVisible(props),
  )

  function initExpanded(props) {
    return props.data.Pozycje.some(
      item => item.KwotaRB_Kapitalowe || item.KwotaRP_Kapitalowe) || localStorage.getItem("infoDodatkExpanded") === 'true'
  }

  function initDetailsVisible(props) {
    return props.data.Pozycje.some(
      item => item.PozycjeUzytkownika && item.PozycjeUzytkownika.length !== 0) || localStorage.getItem("infoDodatkDetails") === 'true'
  }

  function expand() {
    setIsExpanded(e => !e)
    localStorage.setItem("infoDodatkExpanded", (!isExpanded).toString())
    if(!isExpanded === false)
      localStorage.setItem("infoDodatkDetails", 'false')
  }

  function changeDetailsVisibility() {
    setIsDetailsVisible(d => !d)
    localStorage.setItem("infoDodatkDetails", (!isDetailsVisible).toString())
  }

  return (
    <div
      className={
        props.data.CzyJestInformacjaOPodatkuDochodowym ? '' : 'hide-on-print'
      }
    >
      <div className="header-text">
        <div>INFORMACJA DODATKOWA DOTYCZĄCA PODATKU DOCHODOWEGO</div>
        <FormControlLabel
          className="checkboxLabel"
          control={
            <Checkbox
              name="CzyJestInformacjaOPodatkuDochodowym"
              color="primary"
              checked={props.data.CzyJestInformacjaOPodatkuDochodowym}
              onChange={e => props.onSetSectionData(e, 0)}
            />
          }
          label="Dołącz informację o rozliczeniu różnicy pomiędzy podstawą opodatkowania podatkiem dochodowym a wynikiem finansowym (zyskiem, stratą) brutto"
        />
        {props.data.CzyJestInformacjaOPodatkuDochodowym && (
          <FormControlLabel
            className="checkboxLabel"
            control={
              <Checkbox
                name="Expand"
                color="primary"
                checked={isExpanded}
                onChange={expand}
              />
            }
            label="Włącz widok uwzględniający podział na przychody / koszty z zysków kapitałowych oraz z innych źródeł przychodów"
          />
        )}
        {props.data.CzyJestInformacjaOPodatkuDochodowym && isExpanded && (
          <FormControlLabel
            className="checkboxLabel"
            control={
              <Checkbox
                name="ExpandDetail"
                color="primary"
                checked={isDetailsVisible}
                onChange={changeDetailsVisibility}
              />
            }
            label="Włącz widok pozwalający dodać pozycje uszczegóławiąjące z podstawą prawną"
          />
        )}
      </div>
      {props.data.CzyJestInformacjaOPodatkuDochodowym && (
        <>
          <RoznicaCITRZiSHeader handleToggle={expand} />
          <div className="container">
            <RoznicaCITRZiSList
              isExpanded={isExpanded}
              isDetailsVisible={isDetailsVisible}
              dane={props.data.Pozycje}
              aktualizujSumy={props.aktualizujSumy}
              onSetSectionDataArray={props.onSetSectionDataArray}
              czyKwotyWTysiacach={props.czyKwotyWTysiacach}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default InformacjaDodatkowaPodatekDochodowyOpcjonalna
